import { render, staticRenderFns } from "./addBenificiary.vue?vue&type=template&id=3c48d9e4"
import script from "./addBenificiary.vue?vue&type=script&lang=js"
export * from "./addBenificiary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports